var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopped = function SvgStopped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 23c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.01-11C5.981 1 1 5.982 1 12c0 6.007 4.993 11 11 11m-3.807-6.298a.9.9 0 0 1-.625-1.531l3.16-3.16-3.16-3.16a.9.9 0 0 1-.26-.626c0-.496.4-.884.885-.884.259 0 .464.086.626.259l3.17 3.16 3.203-3.17a.83.83 0 0 1 .615-.27c.485 0 .884.399.884.884a.86.86 0 0 1-.259.636l-3.17 3.17 3.16 3.15a.9.9 0 0 1 .258.636.9.9 0 0 1-.895.906.93.93 0 0 1-.636-.27l-3.16-3.16-3.138 3.16a.91.91 0 0 1-.658.27"
  })));
};
export default SvgStopped;